import { ArrowUpRight, GraduationCap, Home, Star } from "lucide-react";
import { SISTER_SITES } from "@/lib/api";

export function CrossPromoCards() {
  return (
    <div data-testid="cross-promo-cards" className="grid md:grid-cols-2 gap-5">
      <a data-testid="btn-promo-yourrealtorfrank-com" href={SISTER_SITES.com.url} target="_blank" rel="noopener noreferrer"        className="group relative overflow-hidden rounded-2xl bg-brand-navy text-white p-7 sm:p-8 transition-transform duration-300 hover:-translate-y-1">
        <div className="absolute -right-10 -top-10 h-44 w-44 rounded-full bg-brand-red/25 blur-2xl transition-transform duration-500 group-hover:scale-125" />
        <div className="flex items-center gap-1 mb-4">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" />
          ))}
          <span className="ml-2 text-[10px] uppercase tracking-[0.2em] text-white/60 font-semibold">{SISTER_SITES.com.badge}</span>
        </div>
        <h3 className="font-display text-2xl font-bold leading-snug">{SISTER_SITES.com.title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-white/75">{SISTER_SITES.com.description}</p>
        <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-red px-5 py-2.5 text-sm font-bold transition-colors group-hover:bg-brand-red-dark">
          <Home className="h-4 w-4" /> {SISTER_SITES.com.cta} <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
        <span className="mt-3 block text-[11px] font-mono text-white/50">{SISTER_SITES.com.name}</span>
      </a>
      <a data-testid="btn-promo-yourrealtorfrank-net" href={SISTER_SITES.net.url} target="_blank" rel="noopener noreferrer"
        className="group relative overflow-hidden rounded-2xl bg-brand-navy-dark border border-brand-gold/25 text-white p-7 sm:p-8 transition-transform duration-300 hover:-translate-y-1">
        <div className="absolute -right-10 -top-10 h-44 w-44 rounded-full bg-brand-gold/15 blur-2xl transition-transform duration-500 group-hover:scale-125" />
        <div className="mb-4">
          <span className="text-[10px] uppercase tracking-[0.2em] text-brand-gold font-semibold">{SISTER_SITES.net.badge}</span>
        </div>
        <h3 className="font-display text-2xl font-bold leading-snug">{SISTER_SITES.net.title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-white/75">{SISTER_SITES.net.description}</p>
        <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-gold text-brand-navy-dark px-5 py-2.5 text-sm font-bold transition-colors group-hover:bg-brand-gold-warm">
          <GraduationCap className="h-4 w-4" /> {SISTER_SITES.net.cta} <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
        <span className="mt-3 block text-[11px] font-mono text-white/50">{SISTER_SITES.net.name}</span>
      </a>
      <div data-testid="cross-promo-more" className="md:col-span-2 flex flex-wrap items-center gap-x-6 gap-y-2 rounded-2xl border border-brand-border-sand bg-white px-6 py-4">
        <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-brand-terracotta font-bold">More from Frank</span>
        {[SISTER_SITES.us, SISTER_SITES.me].map((s) => (
          <a key={s.url} data-testid={`promo-more-${s.url.split(".").pop()}`} href={s.url} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-bold text-brand-navy transition-colors hover:text-brand-red">
            {s.name} <ArrowUpRight className="h-3.5 w-3.5" />
          </a>
        ))}
      </div>
    </div>
  );
}

export function FrankCallout() {
  return (
    <div data-testid="frank-local-callout" className="rounded-2xl border border-brand-gold/40 bg-brand-sand-card p-6 sm:p-7">
      <p className="text-[10px] uppercase tracking-[0.22em] font-bold text-brand-terracotta">Frank's Local Recommendation</p>
      <p className="mt-2 text-sm sm:text-base leading-relaxed text-brand-slate">
        Reading about Sierra Vista is the first step — walking the neighborhoods is the second.{" "}
        <a href="https://yourrealtorfrank.com" target="_blank" rel="noopener noreferrer" className="font-semibold text-brand-navy underline decoration-brand-gold decoration-2 underline-offset-4 hover:text-brand-red transition-colors">
          Frank Powell at yourrealtorfrank.com
        </a>{" "}
        knows these streets personally and answers relocation questions within 60 miles of Sierra Vista.
      </p>
    </div>
  );
}
